// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".forum[data-v-7aa90c22]{border-bottom:1px solid #ddd;overflow:auto;padding:10px 15px;background:#fff}.no-of-posts[data-v-7aa90c22]{float:right;text-align:right;color:#000;font-size:11pt;line-height:20px}.forum a[data-v-7aa90c22]{font-weight:700}.latest-post[data-v-7aa90c22]{padding-top:4px;font-size:14px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
